import React, { Fragment, useEffect, useRef, useState, useCallback } from 'react';
import { Container, Row, Col, Card, CardBody } from 'reactstrap';
import { Breadcrumbs } from '../../AbstractElements';
import DataTableComponent from '../../Common/Component/DataTable/DataTableComponent';
import { PlusCircle } from 'react-feather';
import { Link, useNavigate } from 'react-router-dom';
import { Edit } from 'react-feather';
import AddAsoUser from './AddAsoUser';
import fetchWrapper from '../../Common/api/fetchWrapper';
import { API_URL } from '../../Common/Config/Config';
import { toast } from 'react-toastify';
import AgGridTable from '../../Common/Component/AgGridTable';
import { useSelector } from 'react-redux';

const AsoUserlist = () => {
    const [open, setOpen] = useState(false);
    const [showFilter, setShowFilter] = useState(false);
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(false)
    const [orgData, setOrgData] = useState();
    const [addStatus, setAddStatus] = useState(false);
    const navigate = useNavigate();
    const userRef = useRef(null);
    const userData = useSelector(state => state?.user?.userDetails);

    const loadData = async () => {
        userRef?.current?.api?.showLoadingOverlay();
        const options = {
            method: 'GET'
        }
        await fetchWrapper(`${API_URL}/users/licenseDetails`, options)
            .then((res) => {
                console.log(res)
                const data = res.json?.filter(ele => ele?.email !== userData?.email);
                setData(data)
                userRef?.current?.api?.hideOverlay();
            })
            .catch((err) => {
                userRef?.current?.api?.hideOverlay();
                console.error(err)
            })
    }

    const loadOrgData = async () => {
        await fetchWrapper(`${API_URL}/users/orgDetails`)
            .then((res) => {
                console.log(res)
                if (res.status === 200) {
                    setOrgData(res.json[0])
                }
            }, (err) => {
                console.log(err)
            })
    }

    useEffect(() => {
        loadOrgData()
    }, [])


    useEffect(() => {
        loadData()
    }, [addStatus, showFilter])

    const handleStatus = async (userName, status) => {
        let updateStatus = status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE';
        const options = {
            method: 'PUT'
        }
        await fetchWrapper(`${API_URL}/users/${userName}/${updateStatus}`, options)
            .then((res) => {
                console.log(res)
                if (res.status === 200) {
                    if (res?.json?.status === 'INACTIVE') {
                        toast.error('User has been disabled!')
                    } else {
                        toast.success('User has been enabled!')
                    }
                    loadData()
                }
            })
            .catch(err => console.log(err))
    }

    const columnData = [
        {
            headerName: 'Name',
            filter: true,
            flex: 1,
            sortable: true,
            suppressMovable: true,
            valueGetter: (params) => {
                return params.data.firstName + ' ' + params.data.lastName;
            },
            filterParams: {
                filterOptions: ['contains'],
                maxNumConditions: 0,
                buttons: ['reset']
            },
            autoHeight: true,
            wrapText: true,
            cellClass: 'cell-wrap'
        },
        {
            headerName: 'Email Id',
            field: 'email',
            filter: true,
            flex: 1,
            sortable: true,
            suppressMovable: true,
            filterParams: {
                filterOptions: ['contains'],
                maxNumConditions: 0,
                buttons: ['reset']
            }
        },
        {
            headerName: 'License',
            field: 'moduleName',
            filter: true,
            flex: 2,
            sortable: true,
            suppressMovable: true,
            filterParams: {
                filterOptions: ['contains'],
                maxNumConditions: 0,
                buttons: ['reset']
            },
            autoHeight: true,
            wrapText: true,
            cellClass: 'cell-wrap'
        },
        {
            headerName: 'Phone',
            field: 'phone',
            filter: true,
            flex: 1,
            sortable: true,
            suppressMovable: true,
            filterParams: {
                filterOptions: ['contains'],
                maxNumConditions: 0,
                buttons: ['reset']
            }
        },
        {
            headerName: 'Status',
            filter: false,
            width: 100,
            sortable: true,
            suppressMovable: true,
            cellRenderer: (params) => {
                return (
                    <div className='mr-36'>
                        <label className="switch">
                            <input type="checkbox" id="togBtn" checked={params.data.status === 'ACTIVE' ? true : false }
                                onChange={() => handleStatus(params.data.email, params.data.status)}
                            />
                            <div className="slider round">
                                <span className="on"></span>
                                <span className="off"></span>
                            </div>
                        </label>
                    </div>
                )
            }
        },
        {
            headerName: '',
            width: 90,
            cellRenderer: params => {
                return (
                    <Link to={`${process.env.PUBLIC_URL}/edit-user/${params.data.id}`}>
                    <Edit className={`edit-icon`} />
                </Link>
                )
            },
            suppressMovable: true,
        },
    ]

    const handleClick = () => {
        navigate(`${process.env.PUBLIC_URL}/add-user`)
    };

    const onGridReady = useCallback(async(params) => {
        loadData();
    })

    return (
        <Fragment>
            <Container fluid={true}>
                <Row>
                    <Col sm="12">
                        <div className='d-flex mtop-1'>
                            <Breadcrumbs mainTitle="Users" parent="Users" title="List" />
                            <div className="text-right  action_button">
                                <div className="link" onClick={handleClick}>
                                    <i style={{ fontSize: '25px', color: "#2b7704" }} className="icofont  icofont-plus-circle" ></i>
                                    &nbsp;&nbsp;{"Add User"}</div>
                            </div>
                        </div>
                        <Card className=" newtable">
                            <CardBody className='data-tables ptop-0'>
                            <div className="groups-table">
                                    <div className="ag-theme-material ag-style" style={{ width: '100%' }}>
                                        <AgGridTable
                                            columnData={columnData}
                                            tableData={data}
                                            agRef={userRef}
                                            onGridReady={onGridReady}
                                        />
                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                    </Col>
                    {open && <AddAsoUser value={open} setOpenModal={setOpen} orgData={orgData} setAdd={setAddStatus} />}
                </Row>
            </Container>
        </Fragment>
    );

};

export default AsoUserlist;